const boxStyles = {
  borderRadius: '20px',
  border: '0.5px solid var(--Text-Colour-Primary-Grey, #504949)',
  background: 'var(--White, #FFF)',
};

export default boxStyles;